/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

export default
class Serializer {

    public static deepClone(obj: any) {
        return this.Copy(obj, true);
    }

    public static shallowClone(obj: any) {
        return this.Copy(obj, false);
    }

    private static Copy(obj: any, deep: boolean) {
        let copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) {
            return obj;
        }

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                if (deep) {
                    copy[i] = Serializer.Copy(obj[i], deep);
                }
                else {
                    copy[i] = obj[i];
                }
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (let attr in obj) {
                if (deep) {
                    if (obj.hasOwnProperty(attr)) {
                        copy[attr] = Serializer.Copy(obj[attr], deep);
                    }
                }
                else {
                    if (obj.hasOwnProperty(attr)) {
                        copy[attr] = obj[attr];
                    }
                }
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }
}
